var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { height: "100%", "content-class": "pnmgw__dialog" },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _vm.iFrameIsLoading
        ? _c(
            "div",
            { staticClass: "payments__spinner payments__spinner__override" },
            [
              _c("v-progress-circular", { attrs: { indeterminate: "" } }),
              _vm._v(
                "\n    " + _vm._s(_vm.$t("Transaction.PleaseWait")) + "\n  "
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        {
          staticClass: "pnmgw__dialog__card",
          class: { hidden: _vm.iFrameIsLoading }
        },
        [
          _c("NuveiDialogHeader", {
            attrs: { type: _vm.type },
            on: {
              closeNuveiDialog: function($event) {
                return _vm.closeAction()
              }
            }
          }),
          _vm._v(" "),
          _c("iframe", {
            ref: "nuveiCard",
            staticClass: "pnmgw__dialog__card__iframe",
            attrs: { src: _vm.redirectionUrl, allowpaymentrequest: "" },
            on: {
              load: function($event) {
                return _vm.stopSpinner()
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31d01de6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31d01de6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/nuvei/NuveiDialog.vue
// module id = null
// module chunks = 